
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component } from 'vue-property-decorator';
import WidgetMixins from '../../mixins/WidgetMixins';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { email, required } from 'vee-validate/dist/rules';
import { mixins } from 'vue-class-component';
import { LoginState } from '@/types/types';
import { namespace } from 'vuex-class';
import AuthLayout, { IPanelRow, IPanelStat } from './components/AuthLayout.vue';

extend('email', {
  ...email,
  message: 'Email is not valid',
});
extend('required', {
  ...required,
  message: 'Field is required',
});

const authModule = namespace('auth');

@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
    AuthLayout,
  },
})
export default class Login extends mixins(WidgetMixins) {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  @authModule.Action('login') actionLogin!: any;
  username: string = '';
  password: string = '';
  show: boolean = false;

  panelRows: IPanelRow[] = [
    {
      icon: 'sms',
      title: 'Bulk & Personalized SMS',
      text: 'Send to thousands of contacts with delivery reports in real time.',
    },
    {
      icon: 'campaign',
      title: 'Campaigns & Scheduling',
      text: 'Plan events and schedule messages ahead of the moment.',
    },
    {
      icon: 'insights',
      title: 'Reports & Insights',
      text: 'Track statuses — pending, delivered or failed — at a glance.',
    },
  ];

  panelStats: IPanelStat[] = [
    { value: 'Ghana', label: 'Proudly headquartered' },
    { value: 'VAS', label: 'Telecom specialists' },
    { value: '24/7', label: 'Local support' },
  ];

  authenticate(): void {
    this.actionLogin({
      username: this.username?.trim(),
      password: this.password,
      redirect: this.$route.query.redirect as string,
    } as LoginState & { redirect: string });
  }
}
